exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-ba8d3584] .el-card__body{height:100%}[data-v-ba8d3584] .el-icon-arrow-right{display:none}[data-v-ba8d3584] .el-badge__content{top:10px}", ""]);

// exports
